/**
 * Reduces the state based on the given action.
 *
 * @param {Object} state - The current state.
 * @param {Object} action - The action to be performed.
 * @param {string} action.type - The type of the action.
 * @param {any} action.payload - The payload of the action.
 * @return {Object} The new state.
 * @throws {Error} If the action type is unhandled.
 */
export const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_REMAINING_ATTEMPTS':
            return { ...state, remainingAttempts: action.payload };
        case 'SET_FAIL_ATTEMPT_BANNER':
            return { ...state, failAttemptBanner: action.payload };
        case 'SET_LOCKED_OUT':
            return { ...state, lockedOut: action.payload };
        case 'SET_INCOMPLETE_ENTRY':
            return { ...state, incompleteEntry: action.payload };
        case 'SET_LOCKOUT_TIME':
            return { ...state, lockoutTime: action.payload };
        case 'SET_FUTURE_TIMESTAMP':
            return { ...state, futureTimestamp: action.payload };
        case 'SET_CALLING_VERIFY':
            return { ...state, callingVerify: action.payload };
        case 'SET_UNHANDLED_ERROR_STATE':
            return { ...state, unhandledErrorState: action.payload };
        case 'SET_SHOW_SPLASH':
            return { ...state, showSplash: action.payload };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
